"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.togglePressStyles = exports.toggleFocusStyles = exports.toggleHoverStyles = exports.ToggleButton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const react_stately_1 = require("react-stately");
const components_1 = require("../components");
const Css_1 = require("../Css");
const utils_1 = require("../utils");
function ToggleButton(props) {
    const { selected: isSelected = false, disabled = false, label, onChange, icon, ...otherProps } = props;
    const [asyncInProgress, setAsyncInProgress] = (0, react_1.useState)(false);
    const isDisabled = !!disabled || asyncInProgress;
    const ariaProps = { "aria-label": label, isSelected, isDisabled, ...otherProps };
    const state = (0, react_stately_1.useToggleState)({
        ...ariaProps,
        onChange: (e) => {
            const result = onChange(e);
            if ((0, utils_1.isPromise)(result)) {
                setAsyncInProgress(true);
                result.finally(() => setAsyncInProgress(false));
            }
            return result;
        },
    });
    const labelRef = (0, react_1.useRef)(null);
    const ref = (0, react_1.useRef)(null);
    const tid = (0, utils_1.useTestIds)(props, label);
    const { isPressed, pressProps } = (0, react_aria_1.usePress)({ ref: labelRef, isDisabled });
    const { inputProps } = (0, react_aria_1.useSwitch)(ariaProps, state, ref);
    const { isFocusVisible: isKeyboardFocus, focusProps } = (0, react_aria_1.useFocusRing)({ ...otherProps, within: true });
    const { hoverProps, isHovered } = (0, react_aria_1.useHover)({ isDisabled });
    const tooltip = (0, components_1.resolveTooltip)(disabled);
    const labelAttrs = {
        ...focusProps,
        ...hoverProps,
        ...pressProps,
        css: {
            ...Css_1.Css.br4.dif.aic.gap1.bgTransparent.gray500.hPx(32).plPx(4).pr1.relative.cursorPointer.w("max-content").smMd
                .selectNone.$,
            ...(isHovered && exports.toggleHoverStyles),
            ...(isPressed && exports.togglePressStyles),
            ...(isSelected && !isDisabled && Css_1.Css.lightBlue700.$),
            ...(isKeyboardFocus && exports.toggleFocusStyles),
            ...(isDisabled && Css_1.Css.gray300.cursorNotAllowed.$),
        },
        ...tid,
    };
    return (0, components_1.maybeTooltip)({
        title: tooltip,
        placement: "top",
        children: ((0, jsx_runtime_1.jsxs)("label", { ...labelAttrs, children: [icon && (0, jsx_runtime_1.jsx)(components_1.Icon, { icon: icon }), label, (0, jsx_runtime_1.jsx)(react_aria_1.VisuallyHidden, { children: (0, jsx_runtime_1.jsx)("input", { ref: ref, ...inputProps, ...tid.value }) })] })),
    });
}
exports.ToggleButton = ToggleButton;
/** Styles */
// Toggle element styles
exports.toggleHoverStyles = Css_1.Css.bgGray100.$;
exports.toggleFocusStyles = Css_1.Css.bshFocus.$;
exports.togglePressStyles = Css_1.Css.bgGray300.$;
